export default __webpack_public_path__ + "static/media/background.ce3cd2a0.png";